module.exports = __webpack_public_path__ + "static/media/logo_ficael_branco.ece70061.png";